import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import * as Sentry from "@sentry/react";

import { AlertProvider } from "./context/AlertContext";
import GlobalAlert from "./components/GlobalAlert";

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  Sentry.init({
    dsn: "https://6bfec38c5c16936627ad2ead310a65c1@o4508572493283328.ingest.us.sentry.io/4508572529131520",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        mask: [".mask-me"],
        unmask: [".unmask-me"],
        networkDetailAllowUrls: ["https://app.plasticise.com.au/api/programs/"],
        networkRequestHeaders: ["X-Custom-Header"],
        networkResponseHeaders: ["X-Custom-Header"]
      })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

library.add(faCircleCheck);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AlertProvider>
      <App />
      <GlobalAlert />
    </AlertProvider>
  </React.StrictMode>
);

reportWebVitals();
